import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, role, loading } = useAuth();
  const location = useLocation();

  // ⏳ Attente Firebase (évite les redirections fantômes)
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Chargement...</p>
      </div>
    );
  }

  // ❌ Non connecté
  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // ❌ Connecté mais pas admin
  if (role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  // ✅ Admin autorisé
  return children;
};

export default AdminRoute;
